var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSidebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9221 22.9335L9.45929 40.857L1 22.9335H4.74717L9.45929 33.1572L14.1779 22.9335H17.9221Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9213 15.1429H1.00391V18.2803H17.9213V15.1429Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9358 15.1429H38.501V40.4198H41.9358V15.1429Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9573 22.9323V18.2809H47.5225V22.9323H44.7207V26.0696H47.5225V40.4198H50.9573V26.0696C50.9573 26.0696 51.9904 26.0696 52.253 26.0696C53.0312 26.0696 53.736 25.6068 54.0809 24.8787C54.2303 24.5634 55.0002 22.9323 55.0002 22.9323H50.9573Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7144 22.7555C21.7753 22.7555 17.7715 26.7475 17.7715 31.6724C17.7715 36.5973 21.7753 40.5893 26.7144 40.5893C31.6536 40.5893 35.6574 36.5973 35.6574 31.6724C35.6574 26.7475 31.6536 22.7555 26.7144 22.7555ZM26.7144 37.2411C23.6471 37.2411 21.1612 34.7482 21.1612 31.6724C21.1612 28.5966 23.6477 26.1037 26.7144 26.1037C29.7818 26.1037 32.2676 28.5966 32.2676 31.6724C32.2676 34.7482 29.7812 37.2411 26.7144 37.2411Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSidebar);
export default __webpack_public_path__ + "static/media/logo-sidebar.2e9e0f26f5a5e23d2f7f4a607bfe6dd5.svg";
export { ForwardRef as ReactComponent };